//Candidato do processo seletivo que passa pela heteroidentificação
import { ResultadoFinal } from '../banca/votacao/Votacao';
import { CandidatoResponsavel } from './CandidatoResponsavel';

export enum StatusCandidato {
    NAO_AVALIADO = "Não avaliado",
    INCONCLUSIVO = "Inconclusivo",
    VALIDADO = "Validado",
    VALIDADO_ANTERIORMENTE = "Validado anteriormente",
    NAO_VALIDADO = "Não validado",
    DELETADO = "Deletado",
    AUSENTE = "Ausente"
}

export enum ResultadoCandidato {
    VALIDADO = "Validado",
    NAO_VALIDADO = "Não validado",
    NULO = "Nulo"
}

export interface CandidatoEdital {
    id: string;
    inscricao: string;
    candidato: Candidato;
    edital: Edital;
}

export interface Edital {
    id: string;
    titulo: string;
}


export interface Candidato {
    id?: string | null;
    nome: string;
    nomeSocial?: string;
    cpf: string;
    passaporte?: string;
    email?: string;
    status: StatusCandidato;
    resultado?: ResultadoFinal | null;
    candidatoResponsavel: CandidatoResponsavel | null;
    resultadoFacial?: ResultadoCandidato | null;
    resultadoVirtual?: ResultadoCandidato | null;
    resultadoRecursal?: ResultadoCandidato | null;
    file_name?: string; //Upload de vídeo
    termo?: string;
    emailResultadoConfirmado?: boolean | null;
    emailResultadoEnviado?: boolean | null;
    duplicidade?: boolean;
    candidatoEditais: {
        editais: CandidatoEdital[]
    }
}

export class CandidatoUtils {
    static getDescricaoStatusCandidato(status: StatusCandidato): string {
        switch (status) {
            case StatusCandidato.NAO_AVALIADO:
                return "Não avaliado";
            case StatusCandidato.INCONCLUSIVO:
                return "Inconclusivo";
            case StatusCandidato.VALIDADO:
                return "Validado";
            case StatusCandidato.VALIDADO_ANTERIORMENTE:
                return "Validado anteriormente";
            case StatusCandidato.AUSENTE:
                return "Ausente";
            case StatusCandidato.NAO_VALIDADO:
                return "Não validado";
            case StatusCandidato.DELETADO:
                return "Deletado";
            default:
                return "Status desconhecido";
        }
    }

    static getOpcoesStatusCandidato(statusOptions: StatusCandidato[]): string[] {
        return statusOptions.map(status => this.getDescricaoStatusCandidato(status));
    }

    static filtrarCandidatosPorStatus(candidatos: Candidato[], status: StatusCandidato[]): Candidato[] {
        return candidatos.filter(candidato => status.includes(candidato.status));
    }

    static filtrarCandidatosPorResultadoIncluindoUndefined(candidatos: Candidato[], resultado: ResultadoFinal[]): Candidato[] {
        return candidatos.filter(candidato => {
            console.log(candidato)
            return !candidato.resultado || resultado.includes(candidato.resultado);
        });
    }
}
